


















































import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import MagicValidator from "../../../magic/MagicValidator.vue";

@Component({
  name: "CodeWidget",
  components: { MagicValidator }
})
export default class CodeWidget extends WidgetBase {}
